module.exports = __webpack_public_path__ + "img/1F511.f9f525d0.svg";